export default __webpack_public_path__ + "static/media/about-people-2.75506ec6.jpg";